import script from "./ShapeSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShapeSettings.vue?vue&type=script&setup=true&lang=ts"

import "./ShapeSettings.vue?vue&type=style&index=0&id=054addec&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-054addec"]])

export default __exports__